import React, { useState } from 'react'
import { TIME_FORMAT } from '../../../constants'
// eslint-disable-next-line no-unused-vars
import { IEvent } from '../../../types'
import { convertType, customDateFormat, isDisplayIconV2 } from '../../../utils'
import styles from '../SAPPCalendar.module.css'
import CustomTooltip from '../common/CustomTooltip'
import { getIconforEvent } from '../../../iconsV2'
import clsx from 'clsx'
import { Dayjs } from 'dayjs'

interface IMonthlyEventProps {
  event: IEvent
  isSameMonth: boolean
  onEventDetail?: (event: IEvent) => void
  isOnDetail?: boolean
  setEventDetail?: (params: {event: IEvent | null, date: Dayjs}) => void
  date: Dayjs
}

const MonthlyEvent = ({
  event,
  isSameMonth,
  onEventDetail,
  isOnDetail = false,
  setEventDetail,
  date
}: IMonthlyEventProps) => {
  const formattedDate =
    customDateFormat(event.startDate, TIME_FORMAT) +
    ' - ' +
    customDateFormat(event.endDate, TIME_FORMAT)
  const iconList = getIconforEvent(event)

  const className = event?.isOverDue
    ? `event-error`
    : isSameMonth
    ? `event-${convertType[event.type] || 'default'}`
    : 'event-default'

  const classNameBefore = event?.isOverDue
    ? `event__before-error`
    : isSameMonth
    ? `event__before-${convertType[event.type] || 'default'}`
    : 'event__before-default'

  const classNameBorder = event?.isOverDue
    ? `event__border-error`
    : isSameMonth
    ? `event__border-${convertType[event.type] || 'default'}`
    : 'event__border-default'

  return (
    <React.Fragment>
      <li
        className={clsx(styles[className], styles['event'], (isOnDetail) && styles[classNameBorder])}
        style={{ cursor: 'pointer'}}
        onClick={() => {
          onEventDetail && onEventDetail({...event, current_date: date})
          setEventDetail && setEventDetail({event: event, date: date})
        }}
      >
     <span
        className={clsx(
          styles['monthly-event__before'],
          styles[classNameBefore]
        )}
      />
      <div className={styles["monthly-event__content"]}>
        <div className={styles['monthly-event__title']}>
          {isDisplayIconV2(event) && (
            <div className={styles['weekly-event__title_icon']}>{iconList}</div>
          )}
         <div className='flex-1 min-w-0'>
          <CustomTooltip title={event.title}>
            <div className={styles['truncate-text']}>{event.title}</div>
          </CustomTooltip>
          </div>
        </div>
        <div className={styles['monthly-event__date']}>
          <CustomTooltip title={formattedDate}>{formattedDate}</CustomTooltip>
        </div>
        {/* <div className={styles['monthly-event__date_tablet']}>
          {iconList}
          <CustomTooltip title={formattedDate}>
            {formattedDateStart}
          </CustomTooltip>
        </div> */}
      </div>
      </li>
    </React.Fragment>
  )
}

export default MonthlyEvent
